module.exports = require('./helpers/bundle-url').getBundleURL('1DUm8') + "discord.a369cd76.svg";